export const AUTOMATED_MAILING_ROUTE_NAMES = {
  OVERVIEW: "webmasterAutomatedMailings",
  MAILINGS: "webmasterAutomatedMailingList",
  LOG: "webmasterAutomatedMailLog",
  CREATE: "webmasterAutomatedMailingCreate",
  EDIT: "webmasterAutomatedMailingEdit",
} as const;
